import {connect} from "react-redux";
import TaggedActivityList from "./list";
import {bindActionCreators} from "redux";
import {taggedAlongList} from "../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    taggedList: state.Dealer.taggedList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            taggedAlongList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TaggedActivityList);
